import { Injectable } from '@angular/core';
import { ApiFilterAttribute, FilterAttributeType, LocalFilterAttribute } from './filter-attribute';

@Injectable()
export class FilterAttributeFactoryService {

  constructor() { }

  createLocalFilterAttribute(propertyName: string, displayName: string, type: FilterAttributeType = FilterAttributeType.String): LocalFilterAttribute {
    const localFilterAttribute = new LocalFilterAttribute();
    localFilterAttribute.propertyName = propertyName;
    localFilterAttribute.displayName = displayName;
    localFilterAttribute.attributeType = type;
    return localFilterAttribute;
  }

  createApiFilterAttribute(propertyName: string, displayName: string, apiRoute: string, type: FilterAttributeType = FilterAttributeType.String): ApiFilterAttribute {
    const apiFilterAttribute = new ApiFilterAttribute();
    apiFilterAttribute.propertyName = propertyName;
    apiFilterAttribute.displayName = displayName;
    apiFilterAttribute.apiRoute = apiRoute;
    apiFilterAttribute.attributeType = type;
    return apiFilterAttribute;
  }
}
